module.exports = __webpack_public_path__ + "static/media/banner-login.e955a11f.png";